import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import React from 'react';

import { InputField } from 'Elements/Form';

import ManufacturerSelect from './shared/ManufacturerSelect';

export default function ProductBasicInfo() {
  return (
    <Card elevation={1}>
      <CardHeader title="Tuotetiedot" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Nimi"
              name="product.name"
              variant="outlined"
              placeholder="Syötä tuotteen nimi"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Perushinta"
              name="product.price"
              variant="outlined"
              placeholder="Syötä oletushinta"
              margin="normal"
              helperText="Hinta, jota käytetään varastoarvon laskemiseen jos asiakkaalla ei ole tuottelle omaa hintaa"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={6}>
            <InputField
              fullWidth
              label="Tuotekoodi"
              name="product.code"
              variant="outlined"
              placeholder="Syötä tuotekoodi"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={6}>
            <InputField
              fullWidth
              label="Urasyvyys"
              name="product.track_depth"
              variant="outlined"
              placeholder="Syötä urasyvyys"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={12}>
            <ManufacturerSelect
              name="product.manufacturer_id"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
